module.exports = __webpack_public_path__ + "static/media/Shop_Purple_Cap@3x.3013559f.png";